import { useStage } from './useStage'

export default () => useStage('facial-authentication-3d')
